import { BaseQueryApi } from '@reduxjs/toolkit/query';
import { RootState } from 'store';

export default function prepareHeaders(
  headers: Headers,
  { getState }: Pick<BaseQueryApi, 'getState' | 'extra' | 'endpoint' | 'type' | 'forced'>,
) {
  const { config } = getState() as RootState;

  if (!config.authToken) {
    throw new Error('Cannot sign the request without an authToken');
  }

  headers.set('Content-Type', 'application/json');
  headers.set('Authorization', config.authToken);
  // A request may pin a different building (a resource shared from another building); only default to config.
  if (!headers.has('Hqo-Building-UUID')) {
    headers.set('Hqo-Building-UUID', config.buildingUuid);
  }
  headers.set('Hqo-App-Brand', config.appBrand);

  return headers;
}
